// extracted by mini-css-extract-plugin
export default {"footer":"App_footer__aawhi","footerStyling":"App_footerStyling__gUdHq","contextMenu":"App_contextMenu__cjCIu","mainContainer":"App_mainContainer__Zrnhn"};